import React, { ComponentProps } from 'react'
import LoyaltyBenefitIcon from './LoyaltyBenefitIcon'
import LoyaltyTierMessageBanner from './LoyaltyTierMessageBanner'

type InheritedLoyaltyTierMessageBannerProps = Omit<ComponentProps<typeof LoyaltyTierMessageBanner>, 'icon'>

interface Props extends InheritedLoyaltyTierMessageBannerProps {
  benefitType: App.LoyaltyBenefitType
}

function LoyaltyTierBenefitMessageBanner({
  benefitType,
  ...rest
}: Props) {
  return <LoyaltyTierMessageBanner
    {...rest}
    icon={<LoyaltyBenefitIcon benefitType={benefitType} />}
  >
  </LoyaltyTierMessageBanner>
}

export default LoyaltyTierBenefitMessageBanner
